import styled from 'styled-components';

// Plain text pill toggle: more discoverable than an icon ("Per side" / "Equal").
// Uses theme.gray[0] (white) background so it visibly lifts off the
// theme.gray[100] Field card it sits inside.
export const Toggle = styled.button`
	font-size: 11px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[700]};
	background: ${({ theme }) => theme.gray[0]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 9999px;
	padding: 2px 8px;
	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}
`;

// Spatial T/R/B/L grid — mirrors the actual padding shape.
// Empty center keeps the inputs visually anchored to their sides.
export const SpatialGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-template-rows: auto auto auto;
	grid-template-areas:
		'.    top    .'
		'left center right'
		'.    bottom .';
	gap: 4px;
	align-items: center;
	justify-items: center;
`;

export const Slot = styled.div<{ $area: 'top' | 'right' | 'bottom' | 'left' | 'center' }>`
	grid-area: ${({ $area }) => $area};
	width: 100%;
	min-height: 24px;
`;
